import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchGeoLocation, submitLead } from "../utils/api";

export const useFormSubmit = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState({ type: "", message: "" });
  const [geoData, setGeoData] = useState(null);
  const [isLoadingGeo, setIsLoadingGeo] = useState(true);
  const navigate = useNavigate();

  // Fetch geolocation data on mount
  useEffect(() => {
    const getGeoData = async () => {
      setIsLoadingGeo(true);
      const data = await fetchGeoLocation();
      setGeoData(data);
      setIsLoadingGeo(false);
    };
    getGeoData();
  }, []);

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    setFormStatus({ type: "", message: "" });

    try {
      const result = await submitLead(formData, geoData);

      if (result.success) {
        setFormStatus({
          type: "success",
          message: result.message || "Thank you! We will contact you soon."
        });
        
        // Redirect to thank you page after 1 second
        setTimeout(() => {
          navigate("/thank-you");
        }, 1000);
      } else {
        setFormStatus({
          type: "error",
          message: result.error
        });
      }
    } catch (error) {
      setFormStatus({
        type: "error",
        message: "An unexpected error occurred. Please try again."
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    formStatus,
    geoData,
    isLoadingGeo,
    handleSubmit
  };
};
